<template>

	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>期货买卖管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 搜索筛选 -->
		<el-card class="box-card" style="margin-bottom: 20px;">
			<el-form :inline="true" class="user-search" :model="formInline">
				<el-form-item label="交易员：">
					<el-input size="small" placeholder="交易员" v-model="formInline.uid" clearable></el-input>
				</el-form-item>
				<el-form-item label="交易员">
					<el-select v-model="formInline.payType" placeholder="请选择" clearable>
						<el-option :label="item.name" :value="item.value" v-for="item in payTypeList" :key="item.value"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="交易日期">
					<datapicker @click="changetime1" :startTime="formInline.sendTimeStart" :endTime="formInline.sendTimeEn"></datapicker>
				</el-form-item>
				<el-form-item label="交易方向">
					<el-select v-model="status" placeholder="请选择交易方向" multiple @change="changeStatus">
						<el-option label="买开" value='buy'></el-option>
						<el-option label="买平" value='sell'></el-option>
						<el-option label="卖开" value='sellshort'></el-option>
						<el-option label="卖平" value='buytocover'></el-option>
					</el-select>
				</el-form-item>
	

				<el-form-item>
					<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
					<!-- <el-button size="small" type="warning" icon="el-icon-delete" @click="clear">清空刷选条件</el-button> -->
					<!-- <el-button size="small" type="danger" @click="postopen">批量发货</el-button>
					<el-button size="small" type="primary" @click="exportList">导出</el-button> -->
					<el-button size="small" type="danger" icon="el-icon-plus" @click="handleadd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;" :row-class-name="tableRowClassName">

			<el-table-column type="expand">
				<template slot-scope="scope">
					<el-table :data="scope.row.bondFuturesTradingRecords" style="width: 100%">
						<el-table-column prop="tradingTime" label="交易时间" align="center"> </el-table-column>
						<el-table-column prop="tradingPrice" label="交易价格" align="center"></el-table-column>
						<el-table-column prop="direction" label="交易方向" align="center">
							<!-- <template slot-scope="scope">
								<div>
								{{formatpayType(direction)}}</div>
							</template> -->
						</el-table-column>
						<el-table-column prop="tradingCount" label="交易手数" align="center"></el-table-column>
						<el-table-column prop="incomeAmount" label="收入" align="center"></el-table-column>
						<el-table-column prop="commissionAmount" label="费用" align="center"></el-table-column>
						<el-table-column prop="profitAmount" label="利润" align="center"></el-table-column>
						<el-table-column align="center" label="操作">
							<template slot-scope="scope">
								<el-button size="mini" @click="handleeditRecord(scope.row)">
									编辑
								</el-button>
								<el-button size="mini" @click="handledeleteRecord(scope.row)">
									删除
								</el-button>
							</template>
						</el-table-column>


					</el-table>

				</template>
			</el-table-column>
			<el-table-column prop="tradingDate" label="交易日期" width="120" align="center"></el-table-column>
			<el-table-column prop="username" label="交易员" width="120" align="center"></el-table-column>
			<el-table-column prop="futuresCode" label="期货代码" width="120" align="center"></el-table-column>
			<el-table-column prop="tradingCount" label="交易次数" width="120" align="center"></el-table-column>
			<el-table-column prop="incomeAmount" label="收入" width="120" align="center"></el-table-column>
			<el-table-column prop="commissionAmount" label="费用" width="120" align="center"></el-table-column>
			<el-table-column prop="profitAmount" label="利润" width="120" align="center"></el-table-column>
			<el-table-column prop="createTime" label="创建时间" width="120" align="center"></el-table-column>
			


			<el-table-column align="center" label="操作">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleedit(scope.row)">
						编辑
					</el-button>
					<el-button size="mini" @click="handledelete(scope.row)">
						删除
					</el-button>
					<el-button size="mini" @click="handleeditRecord(scope.row)">
						添加交易
					</el-button>
					<el-button size="mini" @click="handleshowfenshi(scope.row)">
						查看分时
					</el-button>
				</template>
			</el-table-column>
		</el-table>


		<!-- 分页组件 -->
		<Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>

		<!-- 弹框 -->

		<el-dialog       :close-on-click-modal="false" title="查看详情" :visible.sync="Visible" width="80%"
			@click="closeDialog" center>
			<el-divider content-position="left" class="title">订单信息</el-divider>


			<el-row :gutter="20" v-if="orderDetail&&orderDetail.orderSn">
				<el-col :span="12">
					<div>订单编号:{{orderDetail.orderSn}}</div>
					<div>收货人:{{orderDetail.name}}</div>
					<div>外部编号:{{orderDetail.outTradeNo}}</div>
					<div>订单来源:微信</div>
					<!-- <div>付款方式:{{orderDetail.payType=='wxpay'?'微信付款':orderDetail.payType=='alipay'?'支付宝':''}}</div> -->
					<div>付款方式:{{formatpayType(orderDetail.payType)}}</div>
				</el-col>
				<el-col :span="12">
					<div>支付时间:{{web.formatTime(orderDetail.createTime,'Y-M-D h:m')}}</div>
					<div>收货地址:{{orderDetail.address}}</div>
					<div>物流公司:{{orderDetail.expressCompany?orderDetail.expressCompany:'未发货'}}</div>
					<div>物流单号:{{orderDetail.expressNumber?orderDetail.expressNumber:'未发货'}}</div>
					<div>物流信息:<el-button type="text">查看详情</el-button>
					</div>

				</el-col>

			</el-row>
			<el-divider content-position="left" class="title">商品详情</el-divider>
			<el-table size="small" :data="orderDetail.orderGoods" highlight-current-row v-loading="loading" border
				element-loading-text="拼命加载中" :row-class-name="tableRowClassName">
				<el-table-column prop="goodsName" label="商品名称" width="150" align="center"></el-table-column>
				<el-table-column prop="coverImg" label="商品图" width="150" align="center">
					<template slot-scope="scope">
						<div>
							<el-image style="width: 80px; height: 80px" :src="scope.row.goodsImg">
							</el-image>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="buyNum" label="购买数量" align="center"></el-table-column>
				<el-table-column prop="unitPrice" label="单价" align="center"></el-table-column>
				<el-table-column prop="discount" label="优惠" align="center"></el-table-column>
				<el-table-column prop="rebate" label="折扣" align="center"></el-table-column>
				<el-table-column prop="price" label="小计 （元）" align="center"></el-table-column>
			</el-table>

			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeDialog">返回</el-button>

			</div>
		</el-dialog>


		<el-dialog       :close-on-click-modal="false" title="查看分时" :visible.sync="fenshiDialogVisible" width="80%"
			@click="fenshiDialogVisible=false" center>
			<div id="mainYield" style="width: 800px; height: 600px;"></div>
		</el-dialog>


		<!-- 弹框 添加-->
		<el-dialog :close-on-click-modal="false" title="添加" :visible.sync="dialogVisible">
			<el-form label-width="120px">
				<el-form-item label="日期：" label-width="120px">
					<el-date-picker v-model="editForm.tradingDate" type="date" value-format="yyyy-MM-dd" format="yyyy - MM - dd "  placeholder="选择日期">
					</el-date-picker>
				</el-form-item> 
				<el-form-item label="期货代码：" >
					<el-input v-model="editForm.futuresCode"></el-input>
				</el-form-item>

				<!-- <el-form-item label="资讯类别:">
					<el-select v-model="editForm.classifyId" placeholder="资讯类别" style="width: 120px;">
						<el-option :label="item.name" :value="item.status" v-for="(item,index) in rankType"
							:key="index"></el-option>
					</el-select>
				</el-form-item> -->
				<!-- <quill-edit @content="getContent" :width="800" :height="800" :des="editForm.content"></quill-edit> -->
				<!-- <quill-editor ref="text" v-model="editForm.content" class="myQuillEditor" :options="editorOption" /> -->
			</el-form>
			<span slot="footer" class="dialog-footer" style="display: flex;justify-content: content;">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitedit">提交</el-button>

			</span>
		</el-dialog>

				<!-- 弹框 添加记录-->
		<el-dialog :close-on-click-modal="false" title="添加记录" :visible.sync="recordDialogVisible">
			<el-form>
				<el-form-item label="日期：" label-width="140px">
					<el-date-picker v-model="editForm.tradingTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy - MM - dd HH:mm:ss"  placeholder="选择时间"  style="width:200px">
					</el-date-picker>
				</el-form-item> 
				<el-form-item label="交易价格：" label-width="140px">
					<el-input v-model="editForm.tradingPrice"  style="width:200px"></el-input>
				</el-form-item>

				<el-form-item label="交易方向：" label-width="140px">
					<el-select v-model="editForm.direction"  style="width:200px">
						<el-option label="买开" value='buy'></el-option>
						<el-option label="买平" value='sell'></el-option>
						<el-option label="卖开" value='sellshort'></el-option>
						<el-option label="卖平" value='buytocover'></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="交易手数：" label-width="140px">
					<el-input v-model="editForm.tradingCount" style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="收入：" label-width="140px">
					<el-input v-model="editForm.incomeAmount" style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="费用：" label-width="140px">
					<el-input v-model="editForm.commissionAmount" style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="利润：" label-width="140px">
					<el-input v-model="editForm.profitAmount" style="width:200px"></el-input>
				</el-form-item>


				<!-- <el-form-item label="资讯类别:">
					<el-select v-model="editForm.classifyId" placeholder="资讯类别" style="width: 120px;">
						<el-option :label="item.name" :value="item.status" v-for="(item,index) in rankType"
							:key="index"></el-option>
					</el-select>
				</el-form-item> -->
				<!-- <quill-edit @content="getContent" :width="800" :height="800" :des="editForm.content"></quill-edit> -->
				<!-- <quill-editor ref="text" v-model="editForm.content" class="myQuillEditor" :options="editorOption" /> -->
			</el-form>
			<span slot="footer" class="dialog-footer" style="display: flex;justify-content: content;">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submiteditRecord">提交</el-button>

			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getFuturesQuotes,
		getBondFuturesTradingList,
		addEditBondFuturesTrading,
		delBondFuturesTrading,

		addEditBondFuturesTradingRecord,
		delBondFuturesTradingRecord,

		exportdata,
		getExpressinfondy,
		bindExNoSendOrder,
		closeOrder,
		orderListExport
	} from '../../api/basisMG.js'

	import {
		reqGet
	} from '@/api/axiosFun'
	// 导出模块
	export default {

		data() {
			//数据  
			return {
				time1: [],
				time2: [],
				status: [],
				loading: true,
				Visible: false,
				fenshiDialogVisible: false,
				dialogVisible:false,
				recordDialogVisible:false,
				// formInline: {
				//     start: 0,
				//     length: 5,

				// },
				listData: [],
				// 分页参数
				// pageparm: {
				//     currentPage: 1,
				//     pageSize: 5,
				//     total: 10,
				//     start: 0,
				//     length: 5
				// },
				orderDetail: {},
				expressList: [],
				editForm: {},
				excom: '',
				exno: '',
				payTypeList:[
					{name:'买开',value:'buy'},
					{name:'买平',value:'sell'},
					{name:'卖开',value:'sellshort'},
					{name:'卖平',value:'buytocover'},
				]

			};
		},

		watch: {},

		methods: {
			formatpayType(paytype){
				if(paytype){
					let name
				this.payTypeList.forEach(item=>{
					if(item.value==paytype){
						name = item.name
					}
				})
				return name
				}
				
			},

			handleadd() {
				this.dialogVisible = true
				this.editForm = {}

			},
			handleedit(row) {
				this.dialogVisible = true
				this.editForm = Object.assign({}, row)
				console.log(row.content)
			},
			handleeditRecord(row) {
				this.recordDialogVisible = true
				this.editForm = Object.assign({}, row)
				this.editForm.tradingId=row.id
				console.log(row.content)
			},
			handleshowfenshi(){
				this.fenshiDialogVisible = true

				getFuturesQuotes().then(res => {
					if (res.code == '200') {
						this.allListData=res.data
						this.allListData.forEach(item => {
						if (this.imgDates.indexOf(item.bondDate)<0){
							this.imgDates.push(item.bondDate)
						}
						})
						this.imgDates.sort()
						console.log("this.imgDates",this.imgDates)
						this.cityList.forEach(item => {
							var city=item
							var imgYieldserie=[]
							var imgNetVlaueSerie=[]
							this.allListData.forEach(item => {
							if (item.city==city){
								imgYieldserie.push({
									date: item.bondDate,
									value: item.yield
								})
								imgNetVlaueSerie.push({
									date: item.bondDate,
									value: item.netValue
								})
							}
							})
							this.imgYieldSeries.push({name: city,type: "line",stack: "总量",data: imgYieldserie})
							this.imgNetValueSeries.push({name: city,type: "line",stack: "总量",data: imgNetVlaueSerie})
						})
						this.drawLine("mainYield",'收益率【%】',this.imgYieldSeries)
						this.drawLine("mainNetValue",'净值',this.imgNetValueSeries)
					}
				})

			},
			handledelete(row) {
				this.$confirm('确认删除吗', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delBondFuturesTrading({
						id: row.id
					}).then(res => {
						if (res.code == '200') {
							this.$message({
								message: '删除成功',
								type: 'success'
							})
							this.getdata()
						}
					})
				})
			},

			handledeleteRecord(row) {
				this.$confirm('确认删除吗', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delBondFuturesTradingRecord({
						id: row.id
					}).then(res => {
						if (res.code == '200') {
							this.$message({
								message: '删除成功',
								type: 'success'
							})
							this.getdata()
						}
					})
				})
			},


			submitedit() {
				let param = this.editForm
				// param.upgradeId = this.editForm.id
				this.$confirm('确认提交吗', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					addEditBondFuturesTrading(param).then(res => {
						console.log(res)
						if (res.code == '200') {
							this.$message({
								message: '提交成功',
								type: 'success'
							})
							this.dialogVisible = false
							this.getdata()
						}

					})

				})

			},

			submiteditRecord() {
				let param = this.editForm
				// param.upgradeId = this.editForm.id
				this.$confirm('确认提交吗', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					addEditBondFuturesTradingRecord(param).then(res => {
						console.log(res)
						if (res.code == '200') {
							this.$message({
								message: '提交成功',
								type: 'success'
							})
							this.recordDialogVisible = false
							this.getdata()
						}

					})

				})

			},



			closeOrder(row) {
				let msg = '确认关闭订单吗?'
				this.$confirm(msg, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					closeOrder({
						orderId: row.orderId
					}).then(res => {
						if (res.code == '200') {
							this.$message({
								message: "取消订单成功",
								type: "success"
							})
							this.getdata()
						} else {
							// this.$message.error(res.message)
						}
					})
				})

			},
			tableRowClassName({
				rowIndex
			}) {

				if (rowIndex === 1) {
					return 'warning-row';
				} else if (rowIndex === 3) {
					return 'success-row';
				}
				return '';
			},
			changeStatus(val) {
				console.log(val)
				if (val && val.length) {
					this.formInline.orderStatuss = val.join(",")
				} else {
					this.formInline.orderStatuss = ""
				}

			},
			changetime1(val) {
				if (val.length) {
					this.formInline.sendTimeStart = val[0]
					this.formInline.sendTimeEn = val[1]
				} else {
					this.formInline.sendTimeStart = ""
					this.formInline.sendTimeEn = ""
				}
			},
			changetime2(val) {
				if (val.length) {
					this.formInline.payTimeStart = val[0]
					this.formInline.payTimeEnd = val[1]
				} else {
					this.formInline.payTimeStart = ""
					this.formInline.payTimeEnd = ""
				}
			},
			closeDialog() {
				this.Visible = false
				this.bindNoSendVisible = false
			},
			// 获得商品数据
			getdata() {
				let param = this.formInline
			
				getBondFuturesTradingList(param).then(res => {
					this.saveParams(this.$route.path,this.formInline)
					if (res.code == '200') {
						this.listData = res.data.content
						this.loading = false
						this.pageparm.total = res.data.totalElements
					}
				},
				error=>{
					console.log(error)
					this.loading = false
				}).catch(
					err=>{
						console.log(err)
					this.loading = false
					}
				)
			},
			// 导出订单数据
			exportdata() {
				let param = this.formInline
				console.log(param)
				exportdata(param).then(res => {
					if (res.code == '200') {
						this.listData = res.data.content
						this.loading = false
						this.pageparm.total = res.data.totalElements
					}
				})
			},
			bindExNoSendOrderShow(row) {
				this.bindNoSendVisible = true
				this.editForm = Object.assign({}, row)
			},
			SendOrder() {
				if (this.exno && this.excom) {
					bindExNoSendOrder({
						orderId: this.editForm.orderId,
						excom: this.excom,
						exno: this.exno
					}).then(res => {

						if (res.code == '200') {
							this.excom = ''
							this.exno = ''
							this.bindNoSendVisible = false
							this.getdata()
						}
					})
				} else {
					this.$message.error('请将信息补全！')

				}

			},
			handleExpressEdit(row) {
				// this.expressVisible = true
				console.log(111)
				this.getExpressinfondy(row)
			},
			getExpressinfondy(val) {
				getExpressinfondy({
					orderId: val.orderId
				}).then(res => {
					if (res.code == '200') {
						// let expressList = JSON.parse(res.data).data[0].traces
						let expressList = res.data
						expressList.map((item, index) => {
							console.log((item, index))
							item.size = 'large'
							if (expressList.length - 1 == index) {
								item.type = 'primary'
							} else {
								item.type = 'danger'
							}

							item.icon = 'el-icon-truck'
						})
						this.expressList = expressList
						this.expressVisible = true
						// el-icon-truck
						// size: 'large',
						//   type: 'primary',
						//   icon: 'el-icon-more'
						console.log(this.expressList)

					}
				})
			},
			// getOrderDetail(val) {
			// 	getOrderDetailInfo({
			// 		orderid: val.orderId
			// 	}).then(res => {
			// 		if (res.code == '200') {
			// 			console.log(res)
			// 			this.orderDetail = res.data
			// 		}
			// 	})
			// },
			// 查询
			// search() {
			//     this.formInline.start = 0
			// 	this.pageparm.currentPage = 1
			//     this.getdata(this.formInline)
			// },
			exportList() {
				orderListExport(this.formInline).then(res => {
					console.log('orderListExport', res)
					// if(res.data.size){
					//   reqGet('/manager/order/getOrderListExport',this.formInline)                
					// }
					// reqGet('/manager/order/getOrderListExport',this.formInline)
				})

				// this.exportdata(this.formInline)
			},
			exportListold() {

				reqGet('/manager/order/getOrderListExport', this.formInline)


				// this.exportdata(this.formInline)
			},
			// 清空
			// clear() {
			//     this.formInline = {
			//         start: 0,
			//         length: 10,

			//     }
			//     this.getdata(this.formInline)
			// },

			// 分页插件事件
			// callFather(parm) {
			//     this.pageparm.currentPage = parm.currentPage
			//     this.pageparm.pageSize = parm.pageSize
			//     this.pageparm.start = parm.currentPage - 1
			//     this.pageparm.length = parm.pageSize
			//     this.formInline.start = parm.currentPage - 1
			//     this.formInline.length = parm.pageSize
			//     this.getdata(this.formInline)
			// },
			addFun() {},
			submitFun() {}
		},
		// 创建前状态(里面是操作)
		beforeCreate() {},
		// 创建完毕状态(里面是操作)
		created() {
			this.getParams(this.$route.path)
			console.log('formInline',this.formInline)
			if(this.formInline.orderStatuss){
				this.status = this.formInline.orderStatuss.split(",")
			}
			this.getdata()
		},
		// 挂载前状态(里面是操作)
		beforeMount() {},
		// 挂载结束状态(里面是操作)
		mounted() {},
		// 更新前状态(里面是操作)
		beforeUpdate() {},
		// 更新完成状态(里面是操作)
		updated() {},
		// 销毁前状态(里面是操作)
		beforeDestroy() {},
		// 销毁完成状态(里面是操作)
		destroyed() {}
	};
</script>

<style scoped>

</style>
